// frontend/src/pages/VerificationSentPage.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../services/api'; // Necesitamos api

function VerificationSentPage() {
  const location = useLocation();
  // Recuperamos el email pasado desde la página de registro
  const email = location.state?.email;
  const [resendMessage, setResendMessage] = useState('');
  const [isResending, setIsResending] = useState(false);

  const handleResend = async () => {
    if (!email) {
      setResendMessage('No se pudo determinar el email para reenviar.');
      return;
    }
    setIsResending(true);
    setResendMessage('');
    try {
      const response = await api.post('/auth/resend-verification', { email });
      setResendMessage(response.data.message || 'Email reenviado.');
    } catch (error) {
      setResendMessage('Error al intentar reenviar el email.');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="text-center mt-5">
      <h2>¡Registro Exitoso!</h2>
      <p className="lead">Te hemos enviado un correo electrónico{email ? ` a ${email}` : ''}.</p>
      <p>Por favor, revisa tu bandeja de entrada (y la carpeta de spam) y haz clic en el enlace de verificación para activar tu cuenta.</p>

      {/* Botón para reenviar */}
      <div className="mt-4">
        <p>¿No recibiste el email?</p>
        <button
          className="btn btn-secondary"
          onClick={handleResend}
          disabled={isResending}
        >
          {isResending ? 'Reenviando...' : 'Reenviar email de verificación'}
        </button>
        {resendMessage && <p className="mt-2 text-info">{resendMessage}</p>}
      </div>

      <Link to="/login" className="btn btn-link mt-3">
        Ir a Iniciar Sesión
      </Link>
    </div>
  );
}

export default VerificationSentPage;